import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import userReducer from './../features/stores/user.slice';
import mediakitUserReducer from './../features/stores/mediakitUser.slice';
import changeDataReducer from './../features/stores/changeData.slice';
import configReducer from './../features/stores/config.slice';

export const store = configureStore({
  reducer: {
      user: userReducer,
      mediakitUser: mediakitUserReducer,
      changeData: changeDataReducer,
      config: configReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
